// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-wrapper {\n  min-height: calc(100vh - 64px - 50px - 81px);\n}\n.row {\n  margin-top: 15px;\n}\n.v-card__text {\n  font-size: 1rem !important;\n}\n.col-4 {\n  position: relative;\n  margin-top: -4em;\n}\n.v-breadcrumbs {\n  width: 60%;\n}\n.v-breadcrumbs__item {\n  position: relative;\n  top: 8px;\n}\n.v-breadcrumbs__divider {\n  position: relative;\n  top: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
